import React from 'react';

import cs from 'classnames';

const MaximumChars = ({ length, maxLength, disabled, isResize, isMaxChars }) => {
  if (!maxLength) return null;

  return (
    <span
      className={cs(
        'absolute bottom-2 z-20 text-xs font-500 leading-3',
        isResize ? 'right-6' : 'right-3',
        disabled ? 'text-neutral-400' : isMaxChars ? 'text-danger-500' : 'text-neutral-600'
      )}>
      {`${length} / ${maxLength}`}
    </span>
  );
};

export default MaximumChars;
